// Exact Figma export (Lucide, 2px stroke on a 16px grid). Stroke colour is a prop.
function PaywallWand({ dimensions, col = '#fff' }) {
  return `
    <svg width=${dimensions || '16'} height=${dimensions || '16'} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 2.66613V1.3328M10 10.6661V9.3328M5.33333 5.99947H6.66667M13.3333 5.99947H14.6667M11.8665 7.866L12.6665 8.666M10 5.99947H10.0067M11.8665 4.1328L12.6665 3.3328M2 13.9995L8 7.99947M8.13333 4.1328L7.33333 3.3328" stroke="${col}" stroke-width="2" stroke-linecap="round"/>
    </svg>
  `;
}

export default PaywallWand;
